import MemberBusinessAddressResourceModel from '../../generated/types/model/resource/MemberBusinessAddressResourceModel';

export default class MemberBusinessAddressResourceViewModel extends MemberBusinessAddressResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
